import { render } from "./ApplicationStep1.vue?vue&type=template&id=6a54ca70"
import script from "./ApplicationStep1.vue?vue&type=script&lang=js"
export * from "./ApplicationStep1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__